import settings from '../settings';

export const DEFAULT_PROJECT_EDIT_LOCK_CONFIG = {
  ttlSeconds: 120,
  takeoverClaimSeconds: 20,
  heartbeatIntervalSeconds: 30,
  idleTimeoutSeconds: 1800,
  idleCheckIntervalSeconds: 60,
};

export function getProjectEditLockConfig() {
  return {
    ...DEFAULT_PROJECT_EDIT_LOCK_CONFIG,
    ...(settings.public && settings.public.projectEditLockConfig),
  };
}

const secondsToMs = (seconds) => seconds * 1000;

const projectEditLockConfig = getProjectEditLockConfig();

// Server: lock expires when lastHeartbeatAt is older than this (tab closed / no heartbeat).
export const PROJECT_EDIT_LOCK_TTL_MS = secondsToMs(
  projectEditLockConfig.ttlSeconds,
);

// Server: after handoff, the new editor must heartbeat within this window or the lock expires.
export const PROJECT_EDIT_LOCK_TAKEOVER_CLAIM_MS = secondsToMs(
  projectEditLockConfig.takeoverClaimSeconds,
);

// Client: how often the open edit tab pings the server to refresh lastHeartbeatAt.
export const PROJECT_EDIT_LOCK_HEARTBEAT_INTERVAL_MS = secondsToMs(
  projectEditLockConfig.heartbeatIntervalSeconds,
);

// Client: user idle in edit mode with no unsaved changes → release lock and return to view-only.
export const PROJECT_EDIT_LOCK_IDLE_MS = secondsToMs(
  projectEditLockConfig.idleTimeoutSeconds,
);

// Client: how often to evaluate idle expiry while in edit mode.
export const PROJECT_EDIT_LOCK_IDLE_CHECK_INTERVAL_MS = secondsToMs(
  projectEditLockConfig.idleCheckIntervalSeconds,
);
